var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#CD201F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6657 8.26024C19.4817 7.56737 18.9395 7.02169 18.2511 6.8365C17.0033 6.5 12 6.5 12 6.5C12 6.5 6.99669 6.5 5.7489 6.8365C5.06052 7.02172 4.51835 7.56737 4.33434 8.26024C4 9.51611 4 12.1364 4 12.1364C4 12.1364 4 14.7566 4.33434 16.0125C4.51835 16.7053 5.06052 17.2283 5.7489 17.4135C6.99669 17.75 12 17.75 12 17.75C12 17.75 17.0033 17.75 18.2511 17.4135C18.9395 17.2283 19.4817 16.7053 19.6657 16.0125C20 14.7566 20 12.1364 20 12.1364C20 12.1364 20 9.51611 19.6657 8.26024V8.26024ZM10.3636 14.5154V9.75737L14.5454 12.1364L10.3636 14.5154V14.5154Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f7139d09414dccec6a92a4e120490187.svg";
export { ForwardRef as ReactComponent };